
// Mapeamento de códigos de país para idiomas preferenciais
export const COUNTRY_TO_LANGUAGE: Record<string, string> = {
  BR: 'pt-BR',
  US: 'en-US',
  GB: 'en-GB',
  CA: 'en-CA',
  AU: 'en-AU',
  JP: 'ja-JP',
  KR: 'ko-KR',
  CN: 'zh-CN',
  FR: 'fr-FR',
  DE: 'de-DE',
  IT: 'it-IT',
  ES: 'es-ES',
  MX: 'es-MX',
  AR: 'es-AR',
  RU: 'ru-RU',
  IN: 'hi-IN',
  PT: 'pt-PT',
};

// Mapeamento de nomes de países para códigos ISO
export const COUNTRY_NAME_TO_CODE: Record<string, string> = {
  'Brazil': 'BR',
  'Brasil': 'BR',
  'United States': 'US',
  'United States of America': 'US',
  'USA': 'US',
  'Canada': 'CA',
  'United Kingdom': 'GB',
  'England': 'GB',
  'Japan': 'JP',
  'Japão': 'JP',
  'South Korea': 'KR',
  'Korea': 'KR',
  'China': 'CN',
  'France': 'FR',
  'França': 'FR',
  'Germany': 'DE',
  'Alemanha': 'DE',
  'Italy': 'IT',
  'Itália': 'IT',
  'Spain': 'ES',
  'Espanha': 'ES',
  'Mexico': 'MX',
  'México': 'MX',
  'Argentina': 'AR',
  'Russia': 'RU',
  'Rússia': 'RU',
  'India': 'IN',
  'Índia': 'IN',
  'Portugal': 'PT',
};

/**
 * Converte nome do país para código ISO 3166-1 alpha-2
 */
export const getCountryCode = (countryName: string): string => {
  if (!countryName) return 'BR';
  
  // Primeiro tenta busca exata
  const exactMatch = COUNTRY_NAME_TO_CODE[countryName];
  if (exactMatch) return exactMatch;
  
  // Depois tenta busca case-insensitive
  const lowerCountry = countryName.toLowerCase();
  for (const [name, code] of Object.entries(COUNTRY_NAME_TO_CODE)) {
    if (name.toLowerCase() === lowerCountry) {
      return code;
    }
  }
  
  // Se não encontrar, verifica se já é um código
  if (countryName.length === 2) {
    return countryName.toUpperCase();
  }
  
  // Fallback para Brasil
  return 'BR';
};

/**
 * Determina o idioma baseado no código do país
 */
export const getLanguageFromCountry = (countryCode: string): string => {
  return COUNTRY_TO_LANGUAGE[countryCode] || 'pt-BR';
};

/**
 * Detecta idioma do navegador com fallback
 */
export const detectBrowserLanguage = (): string => {
  if (typeof window === 'undefined') return 'pt-BR';
  
  const browserLang = navigator.language || navigator.languages?.[0];
  if (!browserLang) return 'pt-BR';
  
  // Normalizar formato
  if (browserLang.includes('-')) {
    return browserLang;
  }
  
  // Adicionar região padrão para idiomas sem região
  const langMap: Record<string, string> = {
    'pt': 'pt-BR',
    'en': 'en-US',
    'es': 'es-ES',
    'fr': 'fr-FR',
    'de': 'de-DE',
    'it': 'it-IT',
    'ja': 'ja-JP',
    'ko': 'ko-KR',
    'zh': 'zh-CN',
    'ru': 'ru-RU',
    'hi': 'hi-IN',
  };
  
  return langMap[browserLang] || 'pt-BR';
};
